import { Injectable } from '@angular/core';
import { NotificationsService } from '@modules/notification-management/services/notifications.service';
import {
	IBaseNotificationPayload,
	IEditResponse,
	INotificationPayload,
	INotificationsSet,
	Partial,
} from '@modules/notification-management/interfaces/notifications.interface';
import { Observable } from 'rxjs';
import { ISlackChannelsResponse } from '@core/services/integrations/integrations.interface';
import { IntegrationService } from '@core/services/integrations/integration.service';

@Injectable()
export class EditNotificationSetModalService {
	public readonly isUpdating$: Observable<boolean> = this.notificationsService.isUpdatingModal$();

	constructor(private integrationsService: IntegrationService, private notificationsService: NotificationsService) {}

	public hasSlack(): Observable<boolean> {
		return this.integrationsService.hasSlack();
	}

	public hasTeams(): Observable<boolean> {
		return this.integrationsService.hasTeams();
	}

	public edit(payload: Partial<INotificationPayload>): Observable<IEditResponse> {
		return this.notificationsService.editNotificationEntity(payload);
	}

	public getDetails(): Observable<INotificationsSet> {
		return this.notificationsService.getEntity();
	}

	public reset(): void {
		return this.notificationsService.resetNotificationSet();
	}

	public loadDetails(payload: IBaseNotificationPayload): Observable<INotificationsSet> {
		return this.notificationsService.fetchEntity(payload);
	}

	public getSlackChannels(): Observable<ISlackChannelsResponse> {
		return this.notificationsService.getSlackChannels();
	}
}
